import {
  Box,
  Button,
  Divider,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import MenuItemMui from "@mui/material/MenuItem";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Calculate } from "@mui/icons-material";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const AggrigateCrusingValueDetails = ({
  mainData,
  setMainData,
  isNonMobile,
  coatingDesignation,
}) => {
  // console.log("lab test data-", mainData);

  const [errorCheck, setErrorCheck] = useState({
    serialNo: {
      error: false,
    },
    dateOfCast: {
      error: false,
    },
    dateOfTest: {
      error: false,
    },
    weight: {
      error: false,
    },
    coatingDesignation: {
      error: false,
    },
    areaOfCube: {
      error: false,
    },
    compressiveStrength: {
      error: false,
    },
  });

  useEffect(() => {
    handleCalculate();
  }, []);

  const handleCalculate = () => {
    // console.log("maindata", mainData);
    if (!mainData.labTestsDataFromSubs) {
      return;
    }
    const w1_1 = mainData?.labTestsDataFromSubs[1]?.mc;
    const w1_2 = mainData.labTestsDataFromSubs[1]?.mdd;

    const w2_1 = mainData.labTestsDataFromSubs[2]?.mc;
    const w2_2 = mainData.labTestsDataFromSubs[2]?.mdd;

    const w3_1 = Number(w1_1) - Number(w2_1);
    const w3_2 = Number(w1_2) - Number(w2_2);

    const w3_1x100 = (w3_1 / Number(w1_1)) * 100;
    const w3_2x100 = (w3_2 / Number(w1_2)) * 100;

    console.log(w3_1x100);
    console.log(w3_2x100);

    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: pre.labTestsDataFromSubs.map((item, i) =>
        i === 3
          ? { ...item, mc: w3_1, mdd: w3_2 }
          : i === 4
            ? { ...item, mc: w3_1x100.toFixed(2), mdd: w3_2x100.toFixed(2) }
            : i === 5
              ? {
                  ...item,
                  mc: ((Number(w3_1x100) + Number(w3_2x100)) / 2).toFixed(2),
                }
              : item,
      ),
    }));
  };

  const handleDateOfTest = (newVal) => {
    setMainData((pre) => ({
      ...pre,
      dateOfTest: dayjs(newVal).format("YYYY-MM-DD"),
    }));
    // setDatDiff(calculateDaysBetween);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        display="grid"
        gap={0.5}
        alignItems="center"
        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
        sx={{
          "& > div": {
            gridColumn: isNonMobile ? undefined : "span 6",
          },
        }}
      >
        <DemoContainer
          alignContent="center"
          components={["DatePicker"]}
          sx={{ paddingTop: "5px", gridColumn: "span 1" }}
        >
          <Box style={{ width: "190px" }}>
            <DatePicker
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  height: "40px",
                  overflow: "hidden",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  size: "small",
                },
              }}
              label="Date of test"
              timezone="Asia/Colombo"
              format="YYYY-MM-DD"
              // error={errorCheck.dateOfTest.error}
              value={
                mainData.dateOfTest
                  ? dayjs(mainData.dateOfTest).tz("Asia/Colombo", true)
                  : dayjs().tz("Asia/Colombo", true)
              }
              onChange={(newVal) => {
                const colomboTime = newVal?.tz("Asia/Colombo", true);
                handleDateOfTest(colomboTime);
              }}
            />
          </Box>
        </DemoContainer>
        <TextField
          fullWidth
          variant="outlined"
          type="text"
          label="Sample No"
          size="small"
          value={mainData.cement}
          onChange={(e) =>
            setMainData((pre) => ({
              ...pre,
              cement: e.target.value,
            }))
          }
          sx={{ gridColumn: "span 1", marginTop: "5px" }}
        />
        <TextField
          select
          label="Aggrigate"
          fullWidth
          size="small"
          error={errorCheck.coatingDesignation.error}
          defaultValue=""
          sx={{ marginTop: "5px", gridColumn: "span 1" }}
          value={mainData.concreteMixture}
          onChange={(e) => {
            const selectedValue = e.target.value;
            const selectedOption = coatingDesignation.find(
              (item) => item.value === selectedValue,
            );
            console.log(selectedOption);
            setMainData((pre) => ({
              ...pre,
              concreteMixture: e.target.value,
            }));
          }}
        >
          {coatingDesignation.map((data) => (
            <MenuItemMui
              key={data.id}
              data-label={data.label}
              value={data.value}
            >
              {data.label}
            </MenuItemMui>
          ))}
        </TextField>
      </Box>
      <Divider sx={{ margin: "5px 0px 5px 0" }} />

      <Box justifyItems="center">
        <Paper variant="elevation" elevation={2} sx={{ padding: "20px" }}>
          <Box
            display="grid"
            gap={0.5}
            alignItems="center"
            gridTemplateColumns="repeat(6, minmax(0, 1fr))"
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 6",
              },
            }}
          >
            <Typography
              variant="h5"
              sx={{ gridColumn: "span 4" }}
              color="success"
              textAlign="center"
            >
              TEST NO
            </Typography>
            <Typography
              variant="h5"
              sx={{ gridColumn: "span 1" }}
              color="success"
              textAlign="center"
            >
              1
            </Typography>
            <Typography
              variant="h5"
              sx={{ gridColumn: "span 1" }}
              color="success"
              textAlign="center"
            >
              2
            </Typography>
            <Divider sx={{ gridColumn: "span 6", marginBottom: "10px" }} />
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ gridColumn: "span 4" }}
            >
              <Typography variant="h5" color="info" textAlign="start">
                1. Applied force
              </Typography>
              <Typography variant="h5" color="info" textAlign="start">
                (kN)
              </Typography>
            </Box>
            <TextField
              value={mainData?.labTestsDataFromSubs?.[0]?.mc}
              fullWidth
              variant="outlined"
              label=""
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  labTestsDataFromSubs: pre.labTestsDataFromSubs.map(
                    (item, i) =>
                      i === 0 ? { ...item, mc: e.target.value } : item,
                  ),
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 1",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <TextField
              value={mainData?.labTestsDataFromSubs?.[0]?.mdd}
              fullWidth
              variant="outlined"
              label=""
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  labTestsDataFromSubs: pre.labTestsDataFromSubs.map(
                    (item, i) =>
                      i === 0 ? { ...item, mdd: e.target.value } : item,
                  ),
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 1",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ gridColumn: "span 4" }}
            >
              <Typography variant="h5" color="info" textAlign="start">
                2. Weight of Aggregate passing 14.0mm and retained on 10.0mm
                sieves
              </Typography>
              <Typography variant="h5" color="info" textAlign="start">
                W1(g)
              </Typography>
            </Box>
            <TextField
              value={mainData?.labTestsDataFromSubs?.[1]?.mc}
              fullWidth
              variant="outlined"
              label=""
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  labTestsDataFromSubs: pre.labTestsDataFromSubs.map(
                    (item, i) =>
                      i === 1 ? { ...item, mc: e.target.value } : item,
                  ),
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 1",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <TextField
              value={mainData?.labTestsDataFromSubs?.[1]?.mdd}
              fullWidth
              variant="outlined"
              label=""
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  labTestsDataFromSubs: pre.labTestsDataFromSubs.map(
                    (item, i) =>
                      i === 1 ? { ...item, mdd: e.target.value } : item,
                  ),
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 1",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ gridColumn: "span 4" }}
            >
              <Typography variant="h5" color="info" textAlign="start">
                3. Weight of Aggregate retained on 2.36mm Sieve
              </Typography>
              <Typography variant="h5" color="info" textAlign="start">
                W2(g)
              </Typography>
            </Box>
            <TextField
              value={mainData?.labTestsDataFromSubs?.[2]?.mc}
              fullWidth
              variant="outlined"
              label=""
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  labTestsDataFromSubs: pre.labTestsDataFromSubs.map(
                    (item, i) =>
                      i === 2 ? { ...item, mc: e.target.value } : item,
                  ),
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 1",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <TextField
              value={mainData?.labTestsDataFromSubs?.[2]?.mdd}
              fullWidth
              variant="outlined"
              label=""
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  labTestsDataFromSubs: pre.labTestsDataFromSubs.map(
                    (item, i) =>
                      i === 2 ? { ...item, mdd: e.target.value } : item,
                  ),
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 1",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ gridColumn: "span 4" }}
            >
              <Typography variant="h5" color="info" textAlign="start">
                4. Weight of Fines Passing 2.36mm Sieve After Test
              </Typography>
              <Typography variant="h5" color="info" textAlign="start">
                W3=W1-W2 (g)
              </Typography>
            </Box>
            <TextField
              value={mainData?.labTestsDataFromSubs?.[3]?.mc}
              fullWidth
              disabled
              variant="outlined"
              label=""
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  labTestsDataFromSubs: pre.labTestsDataFromSubs.map(
                    (item, i) =>
                      i === 3 ? { ...item, mc: e.target.value } : item,
                  ),
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 1",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <TextField
              value={mainData?.labTestsDataFromSubs?.[3]?.mdd}
              fullWidth
              disabled
              variant="outlined"
              label=""
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  labTestsDataFromSubs: pre.labTestsDataFromSubs.map(
                    (item, i) =>
                      i === 3 ? { ...item, mdd: e.target.value } : item,
                  ),
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 1",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ gridColumn: "span 4" }}
            >
              <Typography variant="h5" color="info" textAlign="start">
                5. Percentage offines passing 2.36mm test sieve
              </Typography>
              <Typography variant="h5" color="info" textAlign="start">
                ACV=W3/W1 X 100%
              </Typography>
            </Box>

            <TextField
              value={mainData?.labTestsDataFromSubs?.[4]?.mc}
              fullWidth
              disabled
              variant="outlined"
              label=""
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  labTestsDataFromSubs: pre.labTestsDataFromSubs.map(
                    (item, i) =>
                      i === 4 ? { ...item, mc: e.target.value } : item,
                  ),
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 1",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <TextField
              value={mainData?.labTestsDataFromSubs?.[4]?.mdd}
              fullWidth
              disabled
              variant="outlined"
              label=""
              onChange={(e) => {
                setMainData((pre) => ({
                  ...pre,
                  labTestsDataFromSubs: pre.labTestsDataFromSubs.map(
                    (item, i) =>
                      i === 4 ? { ...item, mdd: e.target.value } : item,
                  ),
                }));
              }}
              type="number"
              size="small"
              sx={{
                gridColumn: "span 1",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ gridColumn: "span 4" }}
            >
              <Typography variant="h5" color="info" textAlign="start">
                6. Aggregate Crushing Value
              </Typography>
              <Typography variant="h5" color="info" textAlign="start">
                %
              </Typography>
            </Box>

            <TextField
              value={mainData?.labTestsDataFromSubs?.[5]?.mc}
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{
                gridColumn: "span 2",
                "& input": {
                  textAlign: "center",
                },
              }}
            />
          </Box>
          <Divider sx={{ marginBottom: "10px", marginTop: "10px" }} />
          <Button
            size="small"
            variant="contained"
            color="secondary"
            startIcon={<Calculate />}
            onClick={handleCalculate}
          >
            Calculate
          </Button>
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default AggrigateCrusingValueDetails;
